import {constant, defaultTo, equals, firstOf, flow, get, groupBy, ifThen} from '@yandex-delivery/utils'

import type {SectionProps as Props, SlotWidgetConfig, WidgetConfig} from '../types'
import {WidgetType} from '../types'

type DropdownListWidgets = {
  headers: SlotWidgetConfig[]
  content: SlotWidgetConfig[]
  hidden: SlotWidgetConfig[]
}
type DropdownListType = keyof DropdownListWidgets

const isHeaderWidget: (widget: SlotWidgetConfig) => boolean = flow(get('accessibility_info.is_header'), equals(true))

const byDropdownListType: (widget: WidgetConfig) => DropdownListType = flow(
  firstOf(ifThen(isHeaderWidget, constant<DropdownListType>('headers'))),
  defaultTo<DropdownListType>('content'),
)

export const groupByDropdownListType: (props: Props) => DropdownListWidgets = flow(
  get('section.widgets'),
  groupBy(byDropdownListType) as unknown as (w: WidgetConfig[]) => DropdownListWidgets,
)

export const toHeader = (header: SlotWidgetConfig): SlotWidgetConfig => {
  return {
    ...header,
    slot: {
      ...header.slot,
      lead: {
        icon_spot: {
          icon: {
            image_tag: 'delivery_clock_fill',
            tint_color: 'text',
          },
          background_color: 'controlMinor',
        },
        type: WidgetType.ICON_SPOT,
      },
    },
  }
}
